import React, { useReducer } from 'react'
import AccessAreaContext from './AccessAreaContext'
import AccessAreaReducer from './AccessAreaReducer';
import { getAccessAreasService } from '../../services/accessAreas';
import { t } from 'i18next';
import { logout } from '../../services/login';
import { SET_FREE_ACCESS } from './types';
import { getSettingService } from '../../services/Settings';

const AccessAreaState = ({ children }) => {
    const initialState = {
        accessAreas: [],
        accessAreasSearcheable: [],
        freeAccess: false,
        isFetching: true,
        canShowMore: false,
        error: false,
        message: '',
        accessAreasSelected: {
            area_id: "",
            code: "",
            description: t('FREE_ACCESS_AREA')
        },
    };

    const [state, dispatch] = useReducer(AccessAreaReducer, initialState)

    const cleanAccessAreaState = () => dispatch({ type: 'CLEAN' })

    const setAccessArea = (accessArea) => dispatch({ type: 'SET_ACCESS_AREAS_SELECTED', payload: accessArea });

    const getAccessAreas = async (buildings) => {
        try {
            const response = await getAccessAreasService({ buildings });
            if (response.ok) {
                dispatch({
                    type: 'GET_AREAS',
                    payload: response.data.response
                });
            } else {
                const errorType = await response.data.json();
                switch (errorType.error_code) {
                    case 'AUTH_ERROR':
                        dispatch({
                            type: 'ERROR_SERVER',
                            payload: t('TOKEN_ERROR')
                        })
                        setTimeout(() => {
                            logout();
                        }, 1000);
                        break;
                    case 'PROFILE_ACCESS_ERROR':
                        dispatch({
                            type: 'ERROR_SERVER',
                            payload: t('PERMISSIONS_ERROR')
                        })
                        setTimeout(() => {
                            logout();
                        }, 1000);
                        break;
                    default:
                        dispatch({
                            type: 'ERROR_SERVER',
                            payload: t('ERROR_TRY_AGAIN')
                        })
                        break;
                }
            }
        } catch (e) {
            dispatch({
                type: 'ERROR_SERVER',
                payload: t('ERROR_TRY_AGAIN')
            })
            console.log(e)
        }
    }

    const getFreeAccessInAreas = async () => {
        const params = '?keyword=mandatory_area_select';
        const items = await getSettingService(params);
        if (items.ok) {
            dispatch({
                type: SET_FREE_ACCESS,
                payload: items.data.response[0].setting_value === '0' ? false : true,
            })
        } else {

            let errorMsg;
            switch (items.data.error_code) {
                case 'PARAM_ERROR':
                    errorMsg = t('ERROR_TRY_AGAIN');
                    break;
                case 'PROFILE_ACCESS_ERROR':
                    errorMsg = t('PERMISSIONS_ERROR');
                    setTimeout(() => {
                        logout();
                    }, 1000);
                    break;
                case 'AUTH_ERROR':
                    errorMsg = t('TOKEN_ERROR');
                    setTimeout(() => {
                        logout();
                    }, 1000);
                    break;
                default:
                    errorMsg = t('ERROR_TRY_AGAIN');
                    break;
            }

            dispatch({
                type: SET_FREE_ACCESS,
                payload: {
                    freeAccess: false,
                }
            })
        }
    }
    return (
        <AccessAreaContext.Provider
            value={{
                accessAreaState: state,
                getAccessAreas,
                setAccessArea,
                cleanAccessAreaState,
                getFreeAccessInAreas
            }}
        >
            {children}
        </AccessAreaContext.Provider>
    )
}

export default AccessAreaState